import { faTools } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function sendScene() {
    return (
        <div data-cy="historic-icon-updateAllSensor">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.sendScene" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faTools} size="lg" style={{ color: '#2184da' }} />
            </Whisper>
        </div>
    );
}
